



























































































































































































































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import StatsService, { StatsData, Window } from '@/services/StatsService'

@Component
export default class Stats extends Vue {
  window: Window = '24h'
  stats: StatsData | null = null
  isPending = false
  isResetting = false
  confirmReset = false

  windowOptions = [
    { label: '24ч', value: '24h' },
    { label: '7 дн', value: '7d' },
    { label: '30 дн', value: '30d' },
  ]

  projectColumns = [
    {
      name: 'project',
      label: 'Проект',
      field: 'project',
      align: 'left' as const,
      sortable: true,
    },
    {
      name: 'requests',
      label: 'Запросы',
      field: 'requests',
      align: 'right' as const,
      sortable: true,
    },
    {
      name: 'avgDuration',
      label: 'Ср. время',
      field: 'avgDuration',
      align: 'right' as const,
      sortable: true,
      format: (v: number) => v + ' мс',
    },
    {
      name: 'errorRate',
      label: '% ошибок',
      field: 'errorRate',
      align: 'right' as const,
      sortable: true,
    },
  ]

  carrierColumns = [
    {
      name: 'name',
      label: 'Перевозчик',
      field: 'name',
      align: 'left' as const,
      sortable: true,
    },
    {
      name: 'requests',
      label: 'Запросы',
      field: 'requests',
      align: 'right' as const,
      sortable: true,
    },
    {
      name: 'success',
      label: 'Успешно',
      field: 'success',
      align: 'right' as const,
      sortable: true,
    },
    {
      name: 'noPrice',
      label: 'Нет цены',
      field: 'noPrice',
      align: 'right' as const,
      sortable: true,
    },
    {
      name: 'failed',
      label: 'Ошибка',
      field: 'failed',
      align: 'right' as const,
      sortable: true,
    },
    {
      name: 'successRate',
      label: '% успеха',
      field: 'successRate',
      align: 'right' as const,
      sortable: true,
    },
  ]

  routeColumns = [
    {
      name: 'route',
      label: 'Направление',
      field: 'route',
      align: 'left' as const,
      sortable: true,
    },
    {
      name: 'project',
      label: 'Проект',
      field: 'project',
      align: 'left' as const,
      sortable: true,
    },
    {
      name: 'requests',
      label: 'Запросы',
      field: 'requests',
      align: 'right' as const,
      sortable: true,
    },
    {
      name: 'empty',
      label: 'Без предложений',
      field: 'empty',
      align: 'right' as const,
      sortable: true,
    },
    {
      name: 'emptyRate',
      label: '% пустых',
      field: 'emptyRate',
      align: 'right' as const,
      sortable: true,
    },
  ]

  errorColumns = [
    {
      name: 'reason',
      label: 'Причина',
      field: 'reason',
      align: 'left' as const,
      sortable: true,
    },
    {
      name: 'count',
      label: 'Кол-во',
      field: 'count',
      align: 'right' as const,
      sortable: true,
    },
  ]

  get windowLabel(): string {
    return { '24h': '24 часа', '7d': '7 дней', '30d': '30 дней' }[this.window]
  }

  get labelEvery(): number {
    return this.window === '24h' ? 6 : this.window === '7d' ? 24 : 72
  }

  get maxRequests(): number {
    if (!this.stats) return 1
    return Math.max(...this.stats.hourly.map(b => b.requests), 1)
  }

  barHeight(requests: number): string {
    if (requests === 0) return '0px'
    return Math.max((requests / this.maxRequests) * 80, 2) + 'px'
  }

  rateColor(rate: number): string {
    if (rate >= 80) return 'positive'
    if (rate >= 50) return 'warning'
    return 'negative'
  }

  formatHour(iso: string): string {
    const d = new Date(iso)
    return (
      d.toLocaleDateString('ru', { day: 'numeric', month: 'short' }) +
      ' ' +
      String(d.getHours()).padStart(2, '0') +
      ':00'
    )
  }

  formatHourShort(iso: string): string {
    const d = new Date(iso)
    return this.window === '24h'
      ? String(d.getHours()).padStart(2, '0')
      : d.getDate() + '/' + (d.getMonth() + 1)
  }

  @Watch('window')
  onWindowChange() {
    this.load()
  }

  created() {
    this.load()
  }

  doReset() {
    this.isResetting = true
    StatsService.reset()
      .then(() => {
        this.confirmReset = false
        this.stats = null
        this.load()
      })
      .finally(() => {
        this.isResetting = false
      })
  }

  load() {
    this.isPending = true
    StatsService.getStats(this.window)
      .then(data => {
        this.stats = data
      })
      .catch(() => {
        this.stats = null
      })
      .finally(() => {
        this.isPending = false
      })
  }
}
